// import SimpleCache from '@thd-olt-global/simple-cache';
// import axios from 'axios';

export const akamaiImageResize = (imageUrlToTransform, size) => {
  const resizeParams = `Resize=(${size},${size})`;

  if (!imageUrlToTransform) {
    return imageUrlToTransform;
  }
  const isAkamaiHost = imageUrlToTransform.includes('thdstatic.com');
  if (!isAkamaiHost) {
    return imageUrlToTransform;
  }
  if (!imageUrlToTransform.includes('?')) {
    return `${imageUrlToTransform}?im=${resizeParams}`;
  }
  if (imageUrlToTransform.includes('im=')) {
    const urlBeforeImParams = imageUrlToTransform.substring(0, imageUrlToTransform.indexOf('im='));
    const imAndRemainderParams = imageUrlToTransform.substring(imageUrlToTransform.indexOf('im='));
    const hasAdditionalParams = imAndRemainderParams.includes('&');
    if (hasAdditionalParams) {
      const remainderOfParams = imAndRemainderParams.substring(imAndRemainderParams.indexOf('&'));
      const imParams = imAndRemainderParams.substring(0, imAndRemainderParams.indexOf('&'));
      return `${urlBeforeImParams}${imParams};${resizeParams}${remainderOfParams}`;
    }
    return `${imageUrlToTransform};${resizeParams}`;
  }
  return `${imageUrlToTransform}&im=${resizeParams}`;
};

// // This is for server side cache. Setting it for 1hr.
// const VIS_NAV_PROMO = new SimpleCache('VISUAL-NAV-CACHE', 60 * 60 * 1000);
// export default class Helpers {
//   static getServerHost = ({ env }) => {
//     const serverDefaultHost = 'https://api.edge-pr.homedepot.com';
//     const devServer = 'https://api.edge-dev.homedepot.com';
//     const stageServer = 'https://api.edge-stage.homedepot.com';
//     const betaServer = 'https://api-beta.edge-pr.homedepot.com';
//     switch (env) {
//       case 'prod':
//         return serverDefaultHost;
//       case 'prod-beta':
//         return betaServer;
//       case 'dev':
//         return devServer;
//       case 'stage':
//         return stageServer;
//       default:
//         return serverDefaultHost;
//     }
//   };

//   static fetchVisualNavPromo = async (env, apiKey) => {
//     const cacheKey = 'visual-nav-promotions-url';
//     const cached = VIS_NAV_PROMO.get(cacheKey);
//     if (cached) {
//       return cached;
//     }
//     const host = Helpers.getServerHost({ env });
//     // eslint-disable-next-line max-len
// eslint-disable-next-line max-len
//     const visualNavPromoURL = `${host}/ContentService/v2/fetchContent?templatePath=/DTCCOMNEW/fetch/collections/promotions.json&key=${apiKey}`;
//     const promise = axios.get(visualNavPromoURL);
//     VIS_NAV_PROMO.add(cacheKey, promise);
//     return promise;
//   };

//   static isValidDate = (promoDate) => {
//     return promoDate instanceof Date && !isNaN(promoDate); //eslint-disable-line
//   };

//   static getParsedDate = (promoDate = '') => {
//     const [year, month, day] = promoDate.split('-');
//     return new Date(year, month - 1, day);
//   };

//   static getPromotion = (holidayList = [], eventDate) => {
//     return holidayList.find((holiday = {}) => {
//       const { startDate, endDate } = holiday;
//       const beginningDate = this.getParsedDate(startDate);
//       const endingDate = this.getParsedDate(endDate);
//       if (this.isValidDate(beginningDate) && this.isValidDate(endingDate)) {
//         return eventDate >= beginningDate && eventDate <= endingDate;
//       }
//       return false;
//     });
//   };
// }
